import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { reportingOp } from 'store/ducks/Reportings';
import { RootState } from 'store/configureStore';
import { set_isAdditionalDisplayed } from 'store/ducks/Reportings/reportingSlice';
import { DataTypeAR } from 'store/ducks/Reportings/types';
import { columns } from 'components/Columns/AR0102Columns';

interface AR0102Props {
  entityName: string;
}

const AR0102: React.FC<AR0102Props> = ({ entityName }) => {
  const { date, is_additional_displayed } = useSelector(
    (state: RootState) => state.reportings,
  );
  const [data, setData] = useState<DataTypeAR[]>([]);
  const dispatch = useDispatch();

  const fetchData = async () => {
    dispatch(set_isAdditionalDisplayed(false));
    const params = {
      entity_name: entityName,
      date,
    };
    try {
      const fetchedData = await reportingOp.fetchAR0102(params);

      if (fetchedData && Array.isArray(fetchedData.filtered_data)) {
        const date = fetchedData.date;
        const formattedData = fetchedData.filtered_data.map(
          (dataItem: any, index: number) => ({
            key: index,
            date,
            entity_name: dataItem.entity_name,
            function_description: dataItem.function_description,
            function_level: dataItem.function_level,
            function_name: dataItem.function_name,
            ict_service_level: dataItem.ict_service_level,
            ict_service_provider_name: dataItem.ict_service_provider_name,
            function_end_date: dataItem.function_end_date,
            function_start_date: dataItem.function_start_date,
            ict_service_end_date: dataItem.ict_service_end_date,
            ict_service_start_date: dataItem.ict_service_start_date,
          }),
        );

        setData(formattedData);
      } else {
        setData([]);
      }
    } catch (error) {
      console.log('Error fetching branches:', error);
      setData([]);
    }
  };

  useEffect(() => {
    if (entityName) {
      fetchData();
    }
  }, [is_additional_displayed, entityName]);

  return (
    <>
      <Table columns={columns} dataSource={data} scroll={{ x: 1000, y: 430 }} />
    </>
  );
};

export default AR0102;
